/**
 * Viewport Enricher Middleware
 * Already handled in BaseEvent metadata, but can add derived metrics
 */

import type { Middleware, CollectedEvent } from '../types.js';

export class ViewportEnricher implements Middleware {
  name = 'viewport-enricher';

  onPostCollect(event: CollectedEvent): CollectedEvent {
    // Add derived viewport metrics
    const aspectRatio = event.viewport_width / event.viewport_height;
    const isMobile = event.viewport_width < 768;
    const isTablet = event.viewport_width >= 768 && event.viewport_width < 1024;
    const isDesktop = event.viewport_width >= 1024;

    return {
      ...event,
      viewport_aspect_ratio: parseFloat(aspectRatio.toFixed(2)),
      device_category: isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop',
      is_mobile: isMobile,
      is_tablet: isTablet,
      is_desktop: isDesktop
    };
  }
}

